export default __webpack_public_path__ + "static/media/lamp-yellow-full.43680acf.svg";